import { __extends } from "tslib";
import React, { Component } from 'react';
// import { appConfig } from '../../config';
import { QuantityInput } from './QuantityInput';
import { clone } from 'lodash';
var baseUrl = process.env.NODE_ENV === 'production' ? '/' : 'http://aws.molohub.com/';
// const QuantityGrid: React.SFC<IProps> = (props) => {
var QuantityGrid = /** @class */ (function (_super) {
    __extends(QuantityGrid, _super);
    function QuantityGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableRef = React.createRef();
        _this.currentRowIndex = 1;
        _this.cellLength = 0;
        _this.tableLength = 0;
        _this.state = {
            currentCellIndex: 0,
            realCellIndex: 2,
            inputsRendered: false
        };
        _this.initialCheck = function () {
            if (_this.tableRef.current !== null) {
                _this.tableLength = _this.tableRef.current.rows.length;
                _this.cellLength = _this.tableRef.current.rows[0].cells.length;
                _this.initialFocus();
            }
        };
        _this.handleKeyUp = function (e) {
            // e.preventDefault()
            // console.log('handlekeyup');
        };
        _this.handleKeyDown = function (e) {
            var isRight = e.key === 'ArrowRight' || e.key === 'Tab';
            var isLeft = e.key === 'ArrowLeft';
            var isUp = e.key === 'ArrowUp';
            var isDown = e.key === 'ArrowDown';
            if (isRight || isLeft || isUp || isDown) {
                e.preventDefault();
                _this.handleNextInput(isRight, isLeft, isDown, isUp);
            }
        };
        _this.handleOnFocus = function (e) {
            e.preventDefault();
            var currentInput = e.target;
            if (_this.tableRef.current) {
                currentInput.select();
                if (currentInput) {
                    var closest = currentInput.closest('td');
                    if (closest) {
                        closest.classList.add('cell-is-active');
                    }
                    var allCells = _this.tableRef.current.getElementsByTagName('td');
                    for (var i in allCells) {
                        if (allCells[i] && allCells[i] !== closest) {
                            if (allCells[i].classList) {
                                allCells[i].classList.remove('cell-is-active');
                            }
                        }
                    }
                }
            }
        };
        _this.handleOnClick = function (e) {
            var field = e.target;
            _this.currentRowIndex = field.closest('tr').rowIndex;
            if (_this.tableRef.current) {
                var inputs = _this.tableRef.current.rows[_this.currentRowIndex].getElementsByTagName('input');
                var _loop_1 = function (key) {
                    var input = inputs[key];
                    if (input === field) {
                        var closest = input.closest('td');
                        if (closest) {
                            _this.setState({ realCellIndex: closest.cellIndex }, function () {
                                input.focus();
                            });
                        }
                    }
                };
                for (var key in inputs) {
                    _loop_1(key);
                }
            }
        };
        return _this;
    }
    QuantityGrid.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps.moloItems !== this.props.moloItems
            || Object.keys(prevProps.moloItems).length !== Object.keys(this.props.moloItems).length
            || this.props.selectedProduct.colorCode !== prevProps.selectedProduct.colorCode) {
            this.setState({ inputsRendered: false });
        }
        if (this.tableRef.current !== null) {
            var rows = document.querySelector('#quantity-grid-table');
            if (rows) {
                var inputs = rows.querySelectorAll('input');
                if (!this.state.inputsRendered) {
                    this.setState({ inputsRendered: true }, function () {
                        _this.initialCheck();
                    });
                }
            }
        }
    };
    QuantityGrid.prototype.handleNextInput = function (isRight, isLeft, isDown, isUp, isClick) {
        var _this = this;
        if (isRight === void 0) { isRight = false; }
        var currentCellIndex = clone(this.state.realCellIndex);
        if (this.tableRef.current !== null) {
            if ((currentCellIndex) === (this.cellLength - 1) && isRight && (!isUp && !isDown)) {
                currentCellIndex = 0;
                this.currentRowIndex++;
                if (this.currentRowIndex === this.tableLength) {
                    this.currentRowIndex = 1;
                }
            }
            else if (isRight && (!isUp && !isDown)) {
                currentCellIndex++;
            }
            else if (isLeft && (!isUp && !isDown)) {
                currentCellIndex--;
                // Triggered when left arrow key is pressed
                // and cell is the first cell.
                if (currentCellIndex < 0) {
                    currentCellIndex = this.cellLength - 1;
                    // When this done in the first row.
                    if (this.currentRowIndex === 1) {
                        this.currentRowIndex = this.tableLength - 1;
                    }
                    else {
                        this.currentRowIndex--;
                    }
                }
            }
            else if (isUp) {
                this.currentRowIndex--;
                if (this.currentRowIndex <= 0) {
                    this.currentRowIndex = this.tableLength - 1;
                }
            }
            else if (isDown) {
                this.currentRowIndex++;
                if (this.currentRowIndex === this.tableLength) {
                    this.currentRowIndex = 1;
                }
            }
            var tds = this.tableRef.current.rows[this.currentRowIndex].getElementsByTagName('td');
            var input_1 = tds[currentCellIndex].getElementsByTagName('input');
            var realCellIndex = 0;
            if (input_1[0]) {
                var closest = input_1[0].closest('td');
                if (closest) {
                    realCellIndex = closest.cellIndex;
                }
            }
            else {
                realCellIndex = currentCellIndex;
            }
            this.setState({ currentCellIndex: currentCellIndex, realCellIndex: realCellIndex }, function () {
                if (input_1[0]) {
                    input_1[0].focus();
                }
                else {
                    _this.handleNextInput(isRight, isLeft, isDown, isUp);
                }
            });
        }
    };
    QuantityGrid.prototype.initialFocus = function () {
        if (this.tableRef.current) {
            var rows = this.tableRef.current.rows;
            if (rows) {
                var _loop_2 = function (i) {
                    var row = rows[i].classList.contains(('active-row'));
                    if (row) {
                        var inputs = rows[i].getElementsByTagName('input');
                        this_1.currentRowIndex = i;
                        if (inputs.length) {
                            var el = inputs[0];
                            el.focus();
                            var closest_1 = el.closest('td');
                            if (closest_1) {
                                var realCellIndex = closest_1.cellIndex;
                                this_1.setState({ realCellIndex: realCellIndex }, function () {
                                    closest_1.scrollIntoView(true);
                                });
                            }
                        }
                        else {
                            // If no inputs where found, scroll to row.
                            var cells = rows[i].getElementsByTagName('td');
                            var closest = cells[0];
                            closest.scrollIntoView(true);
                        }
                        return "break";
                    }
                };
                var this_1 = this;
                for (var i = 0; i < rows.length; i++) {
                    var state_1 = _loop_2(i);
                    if (state_1 === "break")
                        break;
                }
            }
        }
    };
    QuantityGrid.prototype.render = function () {
        var _this = this;
        var _a = this.props, sizes = _a.sizes, moloItems = _a.moloItems, selectedProduct = _a.selectedProduct;
        var indexCounter = 0;
        return (React.createElement("table", { className: "quantity-grid", id: "quantity-grid-table", ref: this.tableRef },
            React.createElement("thead", null,
                React.createElement("tr", { className: "quantity-grid__header" },
                    React.createElement("th", { className: "quantity-grid__cell" }, selectedProduct.description),
                    React.createElement("th", { className: "quantity-grid__cell" }, "Color name"),
                    sizes.map(function (size, index) {
                        return (React.createElement("th", { key: (size.code), className: 'quantity-grid__cell' + ((index + 2) === _this.state.realCellIndex ? ' cell-is-active' : '') },
                            React.createElement("div", null, size.name)));
                    }))),
            React.createElement("tbody", { className: "quantity-grid__body" }, Object.keys(moloItems).map(function (itemKey, key) {
                var myComponentClass = itemKey === (_this.props.selectedProduct.masterId + _this.props.selectedProduct.colorCode) ? 'active-row' : '';
                var imgUrl = baseUrl + 'productimage/' + moloItems[itemKey][0].seasonCode + '/' + moloItems[itemKey][0].masterId + '/' + moloItems[itemKey][0].colorCode + '/small';
                return (React.createElement("tr", { className: "quantity-grid__row ".concat(myComponentClass), key: (moloItems[itemKey][0].itemId + myComponentClass + key) },
                    React.createElement("td", { className: "quantity-grid__cell" },
                        React.createElement("img", { src: imgUrl, alt: moloItems[itemKey][0].colorName })),
                    React.createElement("td", { className: "quantity-grid__cell" }, moloItems[itemKey][0].colorName),
                    moloItems[itemKey].map(function (item, key) {
                        var realAvailable = item.available;
                        if ((_this.props.orderHeader != null) && (_this.props.orderHeader.orderType.toLocaleLowerCase() != 'reorder')) {
                            realAvailable += item.dispnos;
                        }
                        return (_this.props.basket &&
                            React.createElement(QuantityInput, { idx: indexCounter, key: (item.itemId + item.sizeCode + item.sizeName), quantity: +_this.props.basket.basketLines[item.itemId] || '', available: realAvailable, itemId: item.itemId, updateChanges: _this.props.updateChanges, handleKeyDown: _this.handleKeyDown, handleOnFocus: _this.handleOnFocus, handleKeyUp: _this.handleKeyUp, blocked: item.blocked === 1, handeClick: _this.handleOnClick, soldOut: (!+_this.props.basket.basketLines[item.itemId] || +_this.props.basket.basketLines[item.itemId] < 1) && item.available < 1, orderHeader: _this.props.orderHeader }));
                    })));
            }))));
    };
    return QuantityGrid;
}(Component));
export { QuantityGrid };
;
//# sourceMappingURL=QuantityGrid.js.map